import React from "react";

function DeleteIcon() {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="cursor-pointer"
    >
      <rect
        x="0.40332"
        y="0.158203"
        width="23.874"
        height="23.874"
        rx="5"
        fill="#FFE1E1"
      />
      <path
        d="M8.25552 16.861C8.25552 17.6099 8.86825 18.2226 9.61714 18.2226H15.0636C15.8125 18.2226 16.4253 17.6099 16.4253 16.861V10.0529C16.4253 9.304 15.8125 8.69127 15.0636 8.69127H9.61714C8.86825 8.69127 8.25552 9.304 8.25552 10.0529V16.861ZM16.4253 6.64883H14.7232L14.2399 6.16545C14.1173 6.04291 13.9403 5.96802 13.7633 5.96802H10.9175C10.7405 5.96802 10.5635 6.04291 10.4409 6.16545L9.95755 6.64883H8.25552C7.88107 6.64883 7.57471 6.9552 7.57471 7.32964C7.57471 7.70409 7.88107 8.01045 8.25552 8.01045H16.4253C16.7997 8.01045 17.1061 7.70409 17.1061 7.32964C17.1061 6.9552 16.7997 6.64883 16.4253 6.64883Z"
        fill="#FF5252"
      />
    </svg>
  );
}

export default DeleteIcon;
